import { render } from "./ProfileDetailComponent.vue?vue&type=template&id=c8ad5cb4&scoped=true"
import script from "./ProfileDetailComponent.vue?vue&type=script&lang=js"
export * from "./ProfileDetailComponent.vue?vue&type=script&lang=js"

import "./ProfileDetailComponent.vue?vue&type=style&index=0&id=c8ad5cb4&scoped=true&lang=css"

import exportComponent from "/home/runner/work/acp-portal-frontend/acp-portal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8ad5cb4"]])

export default __exports__